import { TEmailAlert, TTimeInStatus } from "~/types/model";
import OrderNotary from "./orderNotary";

export default class Order {

  id!: number;
  status!: number;
  statusName!: string;
  dealershipInitials!: string;
  userId!: number;
  schedulerId!: number;
  customerLocation!: number;
  isVidRequired!: boolean;
  isEsignRequired!: boolean;
  isInkSignRequired!: boolean;
  isNotaryRequired!: boolean;
  isRushRequired!: boolean;
  isAoiThumbprintRequired!: boolean;
  isInsuranceVerificationRequired!: boolean;
  canChangeSigningLocation!: boolean;
  hasMavShippingLabel!: boolean;
  docDeliveryOption!: number;
  isFleet!: boolean | null;
  notaryMustUploadDocs!: boolean;
  caDeliveryForm!: number;
  sealStatus!: number | null;
  sealerId!: number | null;
  timeInStatus!: TTimeInStatus;
  signer1Instructions!: string | null;
  signer2Instructions!: string | null;
  isNotarySearchExhausted!: boolean | null;
  dealerAccountingNotes!: string | null;
  accountingStatus!: number;
  cancellationReason!: string | null;
  isRural!: boolean | null;
  dealerInstructions!: string | null;
  accountingComment!: string | null;
  dealerStoreId!: number;
  onHoldReviewStatus!: number | null;
  onHoldReviewReason!: string | null;
  underReviewStatus!: number | null;
  underReviewReason!: string | null;
  accountingReviewStatus!: number | null;
  accountingReviewReason!: string | null;
  duplicateReviewStatus!: number | null;
  duplicateReviewReason!: string | null;
  cancellationComment!: string | null;
  r1DealJacketId!: number | null;
  notaryBiddingStatus!: number;
  isGuaranteeRequired!: number;
  isSecureOffsiteRequired!: number;
  isSameCarDeliveryAddress!: boolean | null;
  secondFormOfId!: string | null;
  dealerStatementId!: number | null;
  paymentId!: number | null;
  dealerRegionId!: number | null;
  dealerGroupId!: number;
  userPhone!: string;
  userEmail!: string;
  userImage!: string;
  schedulerEmail!: string | null;
  schedulerPhone!: string | null;
  schedulerImage!: string | null;
  customerPhone!: string;
  customerFirstName!: string;
  customerLastName!: string;
  userFullName!: string;
  dealerStorePhone!: string | null;
  dealerStoreName!: string;
  dealerStoreHasNewPaymentPlanModel!: number;
  dealerGroupName!: string;
  dealerGroupSpecialInstructions!: string | null;
  dealerGroupSpecialInstructionsAppliesTo!: string | null;
  dealerStoreAddress!: string | null;
  dealerStoreState!: string;
  dealerStoreCity!: string | null;
  generalManagerName!: string | null;
  generalManagerEmail!: string | null;
  dealerStoreZip!: string | null;
  schedulerFullName!: string;
  sealerFullName!: string | null;
  customerName!: string;
  isInactive!: boolean;
  carrier!: number;
  mavShippingLabelStatus!: number;
  mavOutgoingPickupOption!: string | null;
  mavOutgoingDocsSentPickupInfo!: any | null;
  outgoingShippingLabel!: string | null;
  outgoingShippingAwb!: string | null;
  returnShippingLabel!: string | null;
  returnShippingAwb!: string | null;
  returnCarrier!: number;
  orderNotary!: OrderNotary | null;
  granularStatus!: string;
  vidStatus!: number;
  vidRequestRetriesLeft!: number;
  vidRequest2RetriesLeft!: number | null;
  canAmendDealerAmount!: boolean;
  canIgnoreAccounting!: boolean;
  isExistingCustomer!: boolean;
  servicesAreSelected!: boolean;
  userEmailAlert!: TEmailAlert | null;
  completedTs!: number | null;
  forceCompleteNotifiedTs!: number | null;
  termsAcceptedTs!: number;
  notaryBiddingUpdatedTs!: number;
  schedulerAssignedTs!: number;
  docsSentToNotaryTs!: number | null;
  submittedTs!: number | null;
  statusChangedTs!: number;
  sealedTs!: number | null;
  createdTs!: number;
  updatedTs!: number;

  static STATUS_CANCELLED = -1;
  static STATUS_DRAFT = 0;
  static STATUS_PENDING_VID = 1;
  static STATUS_PENDING_INSURANCE_VERIFICATION = 2;
  static STATUS_PENDING_SECOND_FORM_OF_ID = 3;
  static STATUS_NEW = 4;
  static STATUS_PICK_NOTARY = 5;
  static STATUS_GENERATE_SHIPPING_LABEL = 6;
  static STATUS_PENDING_E_SIGN = 7;
  static STATUS_PENDING_INK_SIGN = 8;
  static STATUS_COMPLETED = 9;
  static STATUS_SEALED = 10;

  static DOC_DELIVERY_OPTION_UPLOAD = 1;
  static DOC_DELIVERY_OPTION_SHIPPING = 2;

  static CUSTOMER_LOCATION_REMOTE = 1;
  static CUSTOMER_LOCATION_IN_STORE = 2;

}